import { Link } from 'react-router-dom';
import React from "react";
import AddIcon from 'mdi-react/AddIcon';
import MinusIcon from 'mdi-react/MinusIcon';

/**

 *
 * @type {*[]}
 */
export const COLUMNS = [

    {
        Header: () => null,
        id: 'expander',
        Cell: ({ row }) => (
            <span {...row.getToggleRowExpandedProps()}>
            {row.isExpanded ? <MinusIcon /> : <AddIcon />}
          </span>
        ),
        width: 30,
        disableSortBy: true,
        canFilter: false,
    },
    {
        Header: "Entrata Property ID",
        accessor: "entrata_property_id",
    },
    {
        Header: "Program ID",
        accessor: "program_id",
        Cell: ({ row, value  }) => (
          <Link to={`/program/view/${value}`}>{row.original.program_name}</Link>
        ),
    },
    {
        Header: "Building unit",
        accessor: "unit_id",
    },
    {
        Header: "Resident email",
        accessor: "resident_email",
    },
    {
        Header: "Transaction date",
        accessor: "transaction_date"
    },
    {
        Header: "Transaction amount",
        accessor: "transaction_amount"
    },
    {
        Header: "Lease Start Date",
        accessor: "lease_start"
    },
    {
        Header: "Lease End Date",
        accessor: "lease_end"
    },
    {
        Header: "Invite approved",
        accessor: "invite_approved"
    },
    {
        Header: "Invite rejected",
        accessor: "invite_rejected"
    },
    {
        Header: "Entrata Feed ID",
        accessor: "entrata_log_id"
    },
    {
        Header: "Created At",
        accessor: "created_at",
        Cell: ({ value }) => new Date(value).toLocaleString(),
    }
]

export const RenderRowSubComponent = ({ row }) => (
    <div style={{ padding: '20px' }}>
      <p>Unit NUmber: {row.original.unit_number ?? 'N/A'} </p>
      <p>Resident Type: {row.original.resident_type ?? 'N/A'} </p>
      <p>Guarantor: {row.original.guarantor_for ?? 'N/A'} </p>
      <p>-----Tech Info:-----</p>
      <p>LogId: <a href={`/entrata-feed-logs/view/${row.original.entrata_log_id}`}>{row.original.entrata_log_id}</a></p>
      <p>Action: {row.original.action ?? 'N/A'}</p>
      <p>Original action: {row.original.original_action ?? 'N/A'}</p>
      <p>Update Command: {row.original.update_info ?? 'N/A'}</p>
      <p>Processed Error: {row.original.processed_error ?? 'N/A'}</p>
    </div>
);


